import "@/App.css";
import "@/styles/new-pages.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { UserProvider } from "@/store/user";
import HomePage from "@/pages/HomePage";
import LessonPage from "@/pages/LessonPage";
import LoginPage from "@/pages/LoginPage";
import AuthCallback from "@/pages/AuthCallback";
import ChatPage from "@/pages/ChatPage";
import ChallengesPage from "@/pages/ChallengesPage";
import ProfilePage from "@/pages/ProfilePage";
import CurriculumPage from "@/pages/CurriculumPage";
import TracksPage from "@/pages/TracksPage";
import TestPage from "@/pages/TestPage";
import AboutPage from "@/pages/AboutPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import IPNoticePage from "@/pages/IPNoticePage";
import AdminPage from "@/pages/AdminPage";
import PricingPage from "@/pages/PricingPage";
import CheckoutMockPage from "@/pages/CheckoutMockPage";
import CheckoutSuccessPage from "@/pages/CheckoutSuccessPage";
import CheckoutFailurePage from "@/pages/CheckoutFailurePage";
import NotFoundPage from "@/pages/NotFoundPage";
import MethodologyPage from "@/pages/MethodologyPage";
import DashboardPage from "@/pages/DashboardPage";
import ContactPage from "@/pages/ContactPage";
import PartnershipsPage from "@/pages/PartnershipsPage";
import BottomNav from "@/components/BottomNav";
import Footer from "@/components/Footer";
import InstallPWAButton from "@/components/InstallPWAButton";
import { NativeAuthListener } from "@/components/NativeAuthListener";

/**
 * AppRouter — synchronously routes OAuth callbacks (URL fragment) before
 * normal routes mount. Prevents race conditions with auth checks.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/lesson/:lessonId" element={<LessonPage />} />
      <Route path="/chat" element={<ChatPage />} />
      <Route path="/challenges" element={<ChallengesPage />} />
      <Route path="/curriculum" element={<CurriculumPage />} />
      <Route path="/tracks" element={<TracksPage />} />
      <Route path="/test/:testId" element={<TestPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/ip-notice" element={<IPNoticePage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/subscriptions" element={<PricingPage />} />
      <Route path="/checkout/mock/:paymentId" element={<CheckoutMockPage />} />
      <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
      <Route path="/checkout/failure" element={<CheckoutFailurePage />} />
      <Route path="/profile" element={<ProfilePage />} />
      <Route path="/methodology" element={<MethodologyPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/partnerships" element={<PartnershipsPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

function App() {
  return (
    <UserProvider>
      <div className="App">
        <BrowserRouter>
          {/* Accessibility: skip-to-content link for keyboard/screen-reader users */}
          <a
            href="#main-content"
            className="skip-to-content"
            data-testid="skip-to-content"
          >
            تخطَّ إلى المحتوى الرئيسيّ
          </a>
          <NativeAuthListener />
          <main id="main-content" tabIndex={-1}>
            <AppRouter />
          </main>
          <Footer />
          <BottomNav />
          <InstallPWAButton />
        </BrowserRouter>
      </div>
    </UserProvider>
  );
}

export default App;
